import { RequirementsRowItem } from "../types";

export const desktopCompanyData: RequirementsRowItem[] = [
  {
    column: "Company Name",
    description: "The name of the organization",
    example: "Retail Employees Superannuation Pty, LTD",
    required: true,
  },
  {
    column: "Company Domain",
    description: "The official web domain of the organization",
    example: "retail-employees.com, www.retail-employees.com ",
  },
  {
    column: "Employees Min",
    description: "The minimum number of employees in the company",
    example: "200",
  },
  {
    column: "Employees Max",
    description: "The maximum number of employees in the company",
    example: "500",
  },
  {
    column: "Industry",
    description: "The industry in which the company operates",
    example: "Finance",
  },
  {
    column: "Subindustry",
    description: "A more specific categorization within the industry",
    example: "Investment Banking within Finance",
  },
  {
    column: "Country/Region",
    description: "The country where the Head Quarters are located",
    example: "Italy",
  },
];

export const hubspotCompanyData: RequirementsRowItem[] = [
  {
    column: "Company Name",
    description: "The name of the organization",
    example: "Retail Employees Superannuation Pty, LTD",
    required: true,
  },
  {
    column: "Company Domain",
    description: "The official web domain of the organization",
    example: "retail-employees.com, www.retail-employees.com ",
  },
  {
    column: "Number of Employees",
    description: "The number of employees in the company",
    example: "200",
  },
  {
    column: "Employees Range",
    description: "The range of employees in the company",
    example: "100-200",
  },
  {
    column: "Industry",
    description: "The industry in which the company operates",
    example: "Finance",
  },
  {
    column: "Country/Region",
    description: "The country where the Head Quarters are located",
    example: "Italy",
  },
];

export const hubspotContactData: RequirementsRowItem[] = [
  {
    column: "First Name",
    description: "The contact’s given name",
    example: "Andrew",
    required: true,
  },
  {
    column: "Last Name",
    description: "The contact’s family name or surname",
    example: "Blake",
    required: true,
  },
  {
    column: "Job Title",
    description: "The professional title of the contact within their company",
    example: "Senior Sales Manager",
    required: true,
  },
  {
    column: "Company Name",
    description: "The name of the organization",
    example: "Retail Employees Superannuation Pty, LTD",
    required: true,
  },
  {
    column: "Country/Region",
    description: "The country where the individual contact is based",
    example: "Italy",
  },
  {
    column: "Employment Seniority",
    description: "The seniority level of the contact within the company",
    example: "Senior",
  },
  {
    column: "Job Function",
    description: "The specific role or responsibility of the contact",
    example: "Business Development",
  },
  {
    column: "Activity Type",
    description: "The type of interaction, such as a call, email or meetings",
    example: "Email",
  },
  {
    column: "Activity Date",
    description: "The date when the interaction took place",
    example: "2024-03-17 14:29",
  },
  {
    column: "Email Direction",
    description: "Indicates whether the email was received or sent",
    example: "Incoming",
  },
  {
    column: "Call duration",
    description:
      "The total length of a phone call, that identifies replied calls",
    example: "0:03:03",
  },
];

export const salesforceCompanyData: RequirementsRowItem[] = [
  {
    column: "Company Name",
    description: "The name of the organization",
    example: "Retail Employees Superannuation Pty, LTD",
    required: true,
  },
  {
    column: "Website",
    description: "The official web domain of the organization",
    example: "retail-employees.com, www.retail-employees.com ",
  },
  {
    column: "Employees",
    description: "The number of employees in the company",
    example: "200",
  },
  {
    column: "Industry",
    description: "The industry in which the company operates",
    example: "Finance",
  },
  {
    column: "Billing Country",
    description: "The country where the Head Quarters are located",
    example: "Italy",
  },
];

export const salesforceContactData: RequirementsRowItem[] = [
  {
    column: "First Name",
    description: "The contact’s given name",
    example: "Andrew",
    required: true,
  },
  {
    column: "Last Name",
    description: "The contact’s family name or surname",
    example: "Blake",
    required: true,
  },
  {
    column: "Job title",
    description: "The professional title of the contact within their company",
    example: "Senior Sales Manager",
    required: true,
  },
  {
    column: "Company Name",
    description: "The name of the organization",
    example: "Retail Employees Superannuation Pty, LTD",
    required: true,
  },
  {
    column: "Mailing Country",
    description: "The country where the individual contact is based",
    example: "Italy",
  },
  {
    column: "Department",
    description: "The department within the company where the contact works",
    example: "Sales",
  },
  {
    column: "Activity Type",
    description: "The type of interaction, such as a call, email or meetings",
    example: "Email",
  },
  {
    column: "Activity Date",
    description: "The date when the interaction took place",
    example: "2024-03-17 14:29",
  },
  {
    column: "Email Direction",
    description: "Indicates whether the email was received or sent",
    example: "Incoming",
  },
  {
    column: "Call duration",
    description:
      "The total length of a phone call, that identifies replied calls",
    example: "0:03:03",
  },
];

export const desktopContactData: RequirementsRowItem[] = [
  {
    column: "First Name",
    description: "The contact’s given name",
    example: "Andrew",
    required: true,
  },
  {
    column: "Last Name",
    description: "The contact’s family name or surname",
    example: "Blake",
    required: true,
  },
  {
    column: "Job Title",
    description: "The professional title of the contact within their company",
    example: "Senior Sales Manager",
    required: true,
  },
  {
    column: "Company Name",
    description: "The name of the organization",
    example: "Retail Employees Superannuation Pty, LTD",
    required: true,
  },
  {
    column: "Country/Region",
    description: "The country where the individual contact is based",
    example: "Italy",
  },
  {
    column: "Seniority",
    description: "The seniority level of the contact within the company",
    example: "Senior",
  },
  {
    column: "Job Function",
    description: "The specific role or responsibility of the contact",
    example: "Business Development",
  },
  {
    column: "Department",
    description: "The department within the company where the contact works",
    example: "Sales",
  },
  {
    column: "Activity Type",
    description: "The type of interaction, such as a call, email or meetings",
    example: "Email",
  },
  {
    column: "Activity Date",
    description: "The date when the interaction took place",
    example: "2024-03-17 14:29",
  },
  {
    column: "Email Direction",
    description: "Indicates whether the email was received or sent",
    example: "Incoming",
  },
  {
    column: "Call duration",
    description:
      "The total length of a phone call, that identifies replied calls",
    example: "0:03:03",
  },
];
